import React from "react";
import "./ExtraContentEditor.css";
import { ThemeButton } from "static/styled/custom.styled";

const PRESET_SECTIONS = [
  "Words of the Day",
  "Vocabulary",
  "Key Terms",
  "Did You Know?"
];

const ExtraContentEditor = ({
  extraContent = [],
  onChange,
  disabled = false
}) => {
  const sections = Array.isArray(extraContent) ? extraContent : [];

  const handleAddSection = (title = "Words of the Day") => {
    const newSection = {
      title: title,
      items: [
        {
          itemTitle: "",
          itemDescription: ""
        }
      ]
    };
    const updated = [...sections, newSection];
    if (onChange) {
      onChange(updated);
    }
  };

  const handleRemoveSection = (sectionIndex) => {
    const updated = sections.filter((_, idx) => idx !== sectionIndex);
    if (onChange) {
      onChange(updated);
    }
  };

  const handleSectionTitleChange = (sectionIndex, newTitle) => {
    const updated = sections.map((sec, idx) => {
      if (idx === sectionIndex) {
        return { ...sec, title: newTitle };
      }
      return sec;
    });
    if (onChange) {
      onChange(updated);
    }
  };

  const handleAddItem = (sectionIndex) => {
    const updated = sections.map((sec, idx) => {
      if (idx === sectionIndex) {
        return {
          ...sec,
          items: [
            ...(sec.items || []),
            {
              itemTitle: "",
              itemDescription: ""
            }
          ]
        };
      }
      return sec;
    });
    if (onChange) {
      onChange(updated);
    }
  };

  const handleRemoveItem = (sectionIndex, itemIndex) => {
    const updated = sections.map((sec, idx) => {
      if (idx === sectionIndex) {
        return {
          ...sec,
          items: (sec.items || []).filter((_, iIdx) => iIdx !== itemIndex)
        };
      }
      return sec;
    });
    if (onChange) {
      onChange(updated);
    }
  };

  const handleItemFieldChange = (sectionIndex, itemIndex, field, value) => {
    const updated = sections.map((sec, idx) => {
      if (idx === sectionIndex) {
        const newItems = (sec.items || []).map((item, iIdx) => {
          if (iIdx === itemIndex) {
            return { ...item, [field]: value };
          }
          return item;
        });
        return { ...sec, items: newItems };
      }
      return sec;
    });
    if (onChange) {
      onChange(updated);
    }
  };

  return (
    <div className="extra-content-editor">
      <div className="extra-content-header">
        <div>
          <h4 className="extra-content-main-title">Extra Structured Content</h4>
          <p className="extra-content-subtitle">
            Add structured educational cards like Words of the Day, Vocabulary, or Fun Facts.
          </p>
        </div>
        {!disabled && (
          <ThemeButton
            type="button"
            primary
            onClick={() => handleAddSection("Custom Section")}
          >
            + Add Section
          </ThemeButton>
        )}
      </div>

      {!disabled && (
        <div className="extra-content-presets">
          <span className="extra-content-preset-label">Quick Presets:</span>
          {PRESET_SECTIONS.map((preset) => (
            <button
              key={preset}
              type="button"
              className="extra-content-preset-btn"
              onClick={() => handleAddSection(preset)}
            >
              + {preset}
            </button>
          ))}
        </div>
      )}

      {sections.length === 0 ? (
        <div className="extra-content-empty-state">
          No extra content sections added yet. Click "+ Add Section" or choose a quick preset above.
        </div>
      ) : (
        sections.map((section, sIdx) => (
          <div key={sIdx} className="extra-content-section-card">
            <div className="extra-content-section-header">
              <input
                type="text"
                className="extra-content-section-title-input"
                value={section.title || ""}
                placeholder="Section Title (e.g. Words of the Day)"
                disabled={disabled}
                onChange={(e) => handleSectionTitleChange(sIdx, e.target.value)}
              />
              {!disabled && (
                <button
                  type="button"
                  className="extra-content-remove-section-btn"
                  onClick={() => handleRemoveSection(sIdx)}
                >
                  <i className="fa fa-trash-o" /> Remove Section
                </button>
              )}
            </div>

            <div className="extra-content-items-container">
              {(section.items || []).map((item, iIdx) => (
                <div key={iIdx} className="extra-content-item-row">
                  <input
                    type="text"
                    className="extra-content-item-title-input"
                    placeholder="Word / Term / Title"
                    value={item.itemTitle || ""}
                    disabled={disabled}
                    onChange={(e) =>
                      handleItemFieldChange(sIdx, iIdx, "itemTitle", e.target.value)
                    }
                  />
                  <input
                    type="text"
                    className="extra-content-item-desc-input"
                    placeholder="(Optional) Meaning / Explanation"
                    value={item.itemDescription || ""}
                    disabled={disabled}
                    onChange={(e) =>
                      handleItemFieldChange(
                        sIdx,
                        iIdx,
                        "itemDescription",
                        e.target.value
                      )
                    }
                  />
                  {!disabled && (
                    <button
                      type="button"
                      className="extra-content-remove-item-btn"
                      title="Remove item"
                      onClick={() => handleRemoveItem(sIdx, iIdx)}
                    >
                      <i className="fa fa-times" />
                    </button>
                  )}
                </div>
              ))}

              {!disabled && (
                <button
                  type="button"
                  className="extra-content-add-item-btn"
                  onClick={() => handleAddItem(sIdx)}
                >
                  <i className="fa fa-plus" /> Add Item
                </button>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ExtraContentEditor;
